import { useTravelSearchContext } from '../../context/TravelSearchProvider'

export function useRoutes() {
  const { state } = useTravelSearchContext()
  const { routesApiData, selectedRoute } = state

  return {
    isRoutesLoading: state.routesApiLoading ?? !routesApiData,
    routesApiData,
    selectedRoute,
  }
}
